import { Pipe, PipeTransform, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidationError } from '../enums/validation-error';
import { ValidationErrorMessageProvider } from '../providers/validation-error-message-provider.service';

@Pipe({
  name: 'validationErrorMessages',
  standalone: true,
})
export class ValidationErrorMessagesPipe implements PipeTransform {
  private readonly provider = inject(ValidationErrorMessageProvider);

  public transform(errors: ValidationErrors): string[] {
    const validationErrors = Object.keys(errors) as ValidationError[];

    return validationErrors.map((error) =>
      this.provider.message(error, errors[error]),
    );
  }
}
